import { Service } from '@/tools'
export class BookingAndReleaseService<T extends TStock.BookingAndRelease> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.BookingAndRelease}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：预放单订单列表
   */
  orderList = (data: T['ApiOrderList']['req']): Promise<T['ApiOrderList']['res']> => this.post2('v1/ApiOrderList', data)

  /**
   * 功能：预放单订单列表
   */
  productList = (data: T['ApiProductList']['req']): Promise<T['ApiProductList']['res']> => this.post2('v1/ApiProductList', data)

  /**
   * 功能：预放单
   */
  releaseOrders = (data: T['ApiReleaseOrders']['req']): Promise<T['ApiReleaseOrders']['res']> => this.post2('v1/ApiReleaseOrders', data, '放单成功')

  /**
   * 功能：根据spu查询sku列表
   */
  querySkuBySpu = (data: T['ApiQuerySkuBySpu']['req']): Promise<T['ApiQuerySkuBySpu']['res']['data']> => this.post2('v1/ApiQuerySkuBySpu', data)
  /**
   * 功能：预放单大中专
   */
  selectUniversityVocationalOrders = (
    data: T['ApiSelectUniversityVocationalOrders']['req']
  ): Promise<T['ApiSelectUniversityVocationalOrders']['res']> => this.post2('v1/ApiSelectUniversityVocationalOrders', data)

  /**
   * 功能：判断是否可以预放单
   */
  checkOrderCanRelease = (
    data: T['ApiCheckOrderCanRelease']['req']
  ): Promise<T['ApiCheckOrderCanRelease']['res']> => this.post2('v1/ApiCheckOrderCanRelease', data)
}
